import request from "@/utils/http"

/**
 *
 * @param {String} defId
 */
export function getProcessHistoryList(workflowId, start, end, page, size, status, title) {
  return request
    .post(
      `/flowable/getProcessInstList`,
      { start, end, page, size, status, title },
      { params: { workflowId } }
    )
    .commonDeal()
}

/**
 * @param {*} instId
 *
 */
export function getProcessHistory(id) {
  return request.get(`/flowable/getProcessInst`, { params: { id } }).commonDeal()
}

export function getSubActivityInstList(parentInstId) {
  return request.get(`/flowable/getSubActivityInstList`, { params: { parentInstId } }).commonDeal()
}

export function getSubProcessVars(processInstId, subProcessId) {
  return request
    .get(`/flowable/getSubProcessVars`, { params: { processInstId, subProcessId } })
    .commonDeal()
}
